import React from "react";
import App from "../components/App";

const Root = () => (
    <div className="boilerplate-root">
        <App/>
    </div>
);

export default Root;